const COLARIS = { machine_name: 'Colaris', machine_id: process.env.REACT_APP_MACHINE_COLARIS };
const CUTTING = { machine_name: 'Cutting', machine_id: process.env.REACT_APP_MACHINE_CUTTING };
const COATING = { machine_name: 'Coating', machine_id: process.env.REACT_APP_MACHINE_COATING };
const COATING_PRESTIGE = { machine_name: 'Coating Prestige Vilt', machine_id: process.env.REACT_APP_MACHINE_COATING };
const COATING_ELEAGANCE = { machine_name: 'Coating Elegance Rubbermix', machine_id: process.env.REACT_APP_MACHINE_COATING };
const COATING_IN_LINE = { machine_name: 'Coating in line', machine_id: process.env.REACT_APP_MACHINE_COATING_IN_LINE };
const SEWING = { machine_name: 'Sewing', machine_id: process.env.REACT_APP_MACHINE_SEWING };
const EFI_PRINTER = { machine_name: 'EFI Printer', machine_id: process.env.REACT_APP_MACHINE_EFI_PRINTER };

const COMBINATION_ONE = [COLARIS, COATING, CUTTING];
const COMBINATION_PRESTIGE = [COLARIS, COATING_PRESTIGE, CUTTING];
const COMBINATION_ELEGANCE = [COLARIS, COATING_ELEAGANCE, CUTTING];
const COMBINATION_TWO = [COLARIS, CUTTING];
const COMBINATION_THREE = [COLARIS, CUTTING, COATING_IN_LINE];
const COMBINATION_FOUR = [COLARIS, CUTTING, SEWING];
const COMBINATION_FIVE = [EFI_PRINTER, CUTTING];
const COMBINATION_SIX = [COLARIS];

const WORKFLOW = {
    200: COMBINATION_ONE,
    600: COMBINATION_ONE,
    411: COMBINATION_ONE,
    415: COMBINATION_ONE,
    5501: COMBINATION_ONE,
    5500: COMBINATION_ONE,
    334: COMBINATION_ONE,
    607: COMBINATION_ONE,
    610: COMBINATION_ONE,
    1003: COMBINATION_ONE,

    414: COMBINATION_TWO,
    201: COMBINATION_TWO,
    352: COMBINATION_TWO,
    413: COMBINATION_TWO,
    700: COMBINATION_TWO,
    701: COMBINATION_TWO,
    705: COMBINATION_TWO,
    1004: COMBINATION_TWO,

    b200: COMBINATION_THREE,
    b411: COMBINATION_THREE,
    b600: COMBINATION_THREE,
    b1002: COMBINATION_THREE,
    b1005: COMBINATION_THREE,
    b5501: COMBINATION_THREE,
    b5500: COMBINATION_THREE,

    498: COMBINATION_SIX,

    499: COMBINATION_FOUR,
    500: COMBINATION_FOUR,

    1001: COMBINATION_PRESTIGE,
    1002: COMBINATION_ELEGANCE,
    1005: COMBINATION_ELEGANCE,

    2000: COMBINATION_FIVE,
    2010: COMBINATION_FIVE,
    2015: COMBINATION_FIVE,
    2020: COMBINATION_FIVE,
    2021: COMBINATION_FIVE,
};

export default WORKFLOW;
